import React from 'react';
import { styled } from '@mui/material/styles';
import { Fade } from '@mui/material';
import Introduction from './components/Introduction';
import LetsTalkLiabilityForm from '../../../components/forms/LetsTalkLiabilityForm';

const LetsTalkLiabilityRoot = styled('div')(({ theme }) => ({}));

const LetsTalkLiability = () => {
    return (
        <Fade in={true}>
            <LetsTalkLiabilityRoot>
                <Introduction />

                <LetsTalkLiabilityForm />
            </LetsTalkLiabilityRoot>
        </Fade>
    );
};

export default LetsTalkLiability;
